export default __webpack_public_path__ + "static/media/1435.8961ce5b.png";